import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
const LocationsDropdown = (props) => {
    const { onChange, value, req, id, disabled } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getLocations = async () => {
        const res = await postMethod("/locations-list");
        if (checkServerData(res)) {
            const locationsList = [],
                data = res.data.list;

            data.forEach((e, i) => {
                locationsList.push({
                    key: i,
                    value: e.location_id,
                    text: e.location_name,
                });
            });
            setList(locationsList);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getLocations();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className="mb-3">
                <Form.Label>
                    {t(`classes.location`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown placeholder={t("choose")} fluid selection options={list} onChange={(e, data) => onChange(data.value)} value={value} id={id} disabled={disabled} />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default LocationsDropdown;
